<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多拼团"
      @load="onLoad"
    >
      <van-row class="BIMTitle" v-for="(item, index) in list" :key="index">
        <van-col :span="24" class="bg-white b-r-3 xz-PinTitle">
          <div class="f-s-8 title" v-if="false">
            <!-- van-multi-ellipsis--l2 -->
            <van-tag
              type="danger"
              class="f-s-5 title-tag xz-button-red f-l-l"
              v-if="item.status"
              >今日免费</van-tag
            >
            <van-tag
              type="warning"
              class="f-s-5 title-tag m-l-02 xz-button-grey f-l-l"
              >{{ item.itname }}</van-tag
            >
            <p class="m-l-02 f-l-l">
              {{ item.title }}
            </p>
          </div>
          <p class="f-s-8 title van-ellipsis">
            <van-tag
              type="danger"
              class="f-s-5 title-tag xz-button-red f-l-l"
              v-if="item.status"
              >今日限免</van-tag
            >
            <van-tag
              type="warning"
              class="f-s-5 title-tag m-l-02 xz-button-grey f-l-l m-r-02"
              v-if="item.itname != null && item.itname != ''"
              >{{ item.itname }}</van-tag
            >
              {{ item.title }}
          </p>
          <van-row>
            <van-col :span="24" class="m-t-06">
              <div style="line-height: 1.6rem" v-if="!item.status">
                <span class="color-o f-s-6"> ¥ </span>
                <span class="color-o f-s-10 money">
                  {{ item.pinprice }}
                </span>
                <span class="xzBIMClass-Original-Price">
                  ¥{{ item.originalprice }}
                </span>
                <van-button
                  type="danger"
                  class="f-l-r xz-button-info GroupBtn f-s-5"
                  :class="
                        item.pinstatus == '1'
                          ? 'xz-button-suc'
                          : 'xz-button-info'
                      "
                  @click="goGroup(item)"
                  >{{ payText(item) }}</van-button
                >
                <span class="f-l-r m-r-02 xz-item-success f-s-5"
                  >已拼{{ item.pingroupbase }}团</span
                >
              </div>

              <!-- 免费 -->
              <div v-else>
                <van-row>
                  <van-col :span="12">
                    <van-row style="font-size: 1rem; color: #f18340"
                      >免费</van-row
                    >
                  </van-col>
                  <van-col :span="12">
                    <van-button
                      class="f-l-r GroupBtn f-s-5"
                      :class="
                        item.pinstatus == '1'
                          ? 'xz-button-suc'
                          : 'xz-button-info'
                      "
                      @click="goGroup(item)"
                      >{{ payBtnText(item) }}</van-button
                    >
                  </van-col>
                </van-row>
              </div>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <!-- </van-cell> -->
    </van-list>
  </div>
</template>

<script>
// import { Dialog } from "vant";
export default {
  data() {
    return {
      time: 1564864842,
      loading: false,
      finished: false,
      list: [],
      pageIndex: 1,
      freeSize: 0,
      ifHaveFree: true,
      scrollTop:0
    };
  },
  methods: {
    // 跳转到去拼团界面
    goGroup(item) {
      // if (localStorage.getItem("setToken") == null) {
      //   localStorage.setItem("BIMType", "true");
      //   this.goLogin();
      // } else {
        // if(item.pinstatus == "4" && localStorage.getItem("setToken") == null){
        //   this.goLogin();
        //   return false
        // }
        // if (item.pinstatus == "4") {
        //   let data = {
        //     pid: item.pid,
        //     paymentway: 1,
        //     orderGroupId: null,
        //   };
        //   this.Api({
        //     url: "api/addDatumOrder",
        //     method: "POST",
        //     data,
        //   }).then(() => {
        //     item.pinstatus = "1";
        //     Dialog.confirm({
        //       title: "领取成功",
        //       message: "资料领取成功,是否现在去查看",
        //     })
        //       .then(() => {
        //         this.$router.push({
        //           path: "/lookData",
        //           query: {
        //             pid: item.pid,
        //           },
        //         });
        //       })
        //       .catch(() => {});
        //   });
        // } 
        if (item.pinstatus == "1") {
          this.$router.push({
            path: "/lookData",
            query: {
              pid: item.pid,
            },
          });
        } else {
          this.$router.push({ path: "/BIMDetials", query: { pid: item.pid } });
        }
      // }
    },
    payBtnText(item) {
      if(item.pinstatus == '1'){
        return '查看资料'
      }
      return "立即领取";
    },
    payText(item){
      if(item.pinstatus == '1'){
        return "查看资料"
      }
      return item.pinnnum + "人拼团";
    },
    onLoad() {
      let _that = this;
      this.Api({
        url: `api/datumList?pageIndex=${this.pageIndex}&freeSize=${this.freeSize}&ifHaveFree=${this.ifHaveFree}`,
        method: "GET",
      }).then((res) => {
        if (res.retuCode == 5000) {
          _that.freeSize = res.data.freeSize;
          _that.ifHaveFree = res.data.ifHaveFree;
          _that.pageIndex += 1;
          res.data.data.forEach((element) => {
            _that.list.push(element);
          });
          this.loading = false;
          if (_that.list.length + 1 >= res.data.total) {
            _that.finished = true; 
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  font-family: "微软雅黑";
}
.money {
  font-weight: 400;
  letter-spacing: 0;
  font-family: PingFangSC-Regular, PingFang SC !important;
}
.BIMTitle {
  padding: 0.7rem 0.8rem 0rem 0.8rem;
}
.xz-item-success {
  color: #73787f;
  font-size: 0.6rem;
  line-height: 1.9rem;
}
.xzBIMClass-Original-Price {
  color: #9da4ad;
  font-size: 0.6rem;
  text-decoration: line-through;
}
// BIM资料头部
.xz-PinTitle {
  padding-top: 1rem;
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  padding-bottom: 0.5rem;
}
.title {
  font-weight: 500;
}
.title-tag {
  height: 0.95rem;
  line-height: 0.95rem;
}
.brief {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  background-color: #f6f6f6;
  color: #9da1ad;
}
.color-o {
  color: #f18340;
}
// 拼团按钮样式
.GroupBtn {
  border-radius: 0.8rem;
  width: 4.5rem;
  height: 1.6rem;
}
.colon {
  display: inline-block;
  margin: 0 4px;
  color: #ee0a24;
}
.block {
  display: inline-block;
  width: 22px;
  color: #fff;
  font-size: 12px;
  text-align: center;
  background-color: #ee0a24;
}
</style>
